import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { baseImgUrl } from '~/utils/constants';

export default function EmptyState({
  title,
  description,
  button,
  imgName,
}: {
  title: string;
  description: string;
  button?: JSX.Element;
  imgName: string;
}) {
  return (
    <Stack justifyContent="center" alignItems="center" px={2} py={2} flex={1}>
      <img
        src={`${baseImgUrl}empty-states/${imgName}-3x.png`}
        srcSet={`${baseImgUrl}empty-states/${imgName}.png, ${baseImgUrl}empty-states/${imgName}-2x.png 2x, ${baseImgUrl}empty-states/${imgName}-3x.png 3x`}
        alt={imgName}
        style={{ maxWidth: 110, marginBottom: 20 }}
      />
      <Typography variant="h6" mb={0.5} textAlign="center" fontWeight={700} color='text.primary'>
        {title}
      </Typography>
      <Typography variant="body2" textAlign="center" mb={2} color='text.secondary'>
        {description}
      </Typography>
      {button}
    </Stack>
  );
}
